import { Typography, Box } from '@mui/material';
import TransText from 'next-translate/TransText';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import CustomCard from '@components/CustomCard';
import { ButtonLink } from '@components/Links';
import PaywallCardSigninHeader from '@components/Paywall/PaywallCardSigninHeader';
import useAmplitude from '@utils/hooks/useAmplitude';
import { TrackingEventName } from '@utils/types/amplitude/events';

const PaywallSignup: FC = () => {
    const { t } = useTranslation('freemium');
    const { track } = useAmplitude();

    const onSignupClick = async () => {
        await track({
            name: TrackingEventName.PAYWALL_BUTTON_CLICKED,
            params: {
                action: 'signup',
            },
        });
    };

    return (
        <CustomCard
            dataTestId="paywall-signup"
            headerContent={<PaywallCardSigninHeader />}
            mainContent={
                <Box sx={{ textAlign: 'center' }}>
                    <Typography component="h3" mb={3} variant="h1">
                        <TransText
                            components={{ br: <br />, strong: <strong /> }}
                            text={t('paywall.signup.description')}
                        />
                    </Typography>
                    <ButtonLink
                        href="/signup?from=freemium_paywall"
                        onClick={onSignupClick}
                        variant="contained"
                    >
                        {t(`paywall.signup.button`)}
                    </ButtonLink>
                </Box>
            }
            withFadeContent
        />
    );
};

export default PaywallSignup;
